import React from "react";
import axios from "axios";
import config from "./config";
import { Base64 } from 'js-base64';

/// Token refresh management
let isRefreshingToken = false;
let refreshQueue = [];
let resolvedToken = null;

//COMMON VARIABLE OF USER DERAILS
let userId, userRole, userEmail, userToken, syncToken, streamData;

// ----------------------
// Axios Instance Setup
// ----------------------
const axiosInstance = axios.create({
  baseURL: config.RootUrl,
  headers: { Accept: "application/json" },
});

// Helper: read cookie
const getCookie = (name) => {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? match[2] : null;
};

// ------------------------------------
// Axios interceptor: attach latest token/deviceId automatically
// ------------------------------------
axiosInstance.interceptors.request.use(
  (request) => {
    const userToken = getCookie("user_token_wc");
    const syncToken = getCookie("sync_token_wc");
    const userDetailsCookie = getCookie("user_details_wc");

    if (userToken && syncToken) {
      config.user_token = userToken;
      config.sync_token = syncToken;
    }

    if (userDetailsCookie) {
      try {
        const firstDecode = Base64.decode(userDetailsCookie);
        const secondDecode = Base64.decode(firstDecode);
        const userDetails = JSON.parse(secondDecode);
        config.deviceId = userDetails?.data?.DeviceId || config.deviceId;
      } catch (err) {
        console.error("Error decoding user_details cookie:", err);
      }
    }

    // Attach tokens + device info to every request header
    request.headers["Authorization"] = "Basic " + config.user_token;
    request.headers["X-Sync-Token"] = config.sync_token;
    request.headers["X-Device-Id"] = config.deviceId;

    return request;
  },
  (error) => Promise.reject(error)
);

// ✅ Optional: Response interceptor — updates tokens if backend sends new ones
axiosInstance.interceptors.response.use(
  (response) => {
    const newSync = response.headers["x-sync-token"];
    const newUserToken = response.headers["authorization"];
    if (newSync || newUserToken) {
      if (newUserToken) {
        document.cookie = `user_token_wc=${newUserToken}; path=/; domain=.vmedulife.com`;
        config.user_token = newUserToken;
      }
      if (newSync) {
        document.cookie = `sync_token_wc=${newSync}; path=/; domain=.vmedulife.com`;
        config.sync_token = newSync;
      }
      // Notify other tabs silently
      localStorage.setItem("token_update", Date.now().toString());
    }
    return response;
  },
  (error) => Promise.reject(error)
);

class LibraryApiCall extends React.Component {

    static async makeApiCall(type, info, apiPath, fileData='') {
        let apiResult = { success: false, APIResult: {}, expired: false };
        userId = config.account == 'faculty' ? config.faculty_id : config.studentId;
        userRole = config.account == 'faculty' ? 'instructor' : 'learner';
        userEmail = config.emailId;
        userToken = config.user_token;
        syncToken = config.sync_token;
        
        // info.InputUserId = userId;
        // info.InputUserRole = userRole;
        // info.deviceId = config.deviceId;
        // info.apiName = type;

        let formData = new FormData();
        formData.append(type, true);
        formData.append('data', Base64.encode(JSON.stringify(info)));

        let parameterData = JSON.stringify({
            source: 'web',
            uid: userId,
            email: userEmail,
            role: userRole
        });

        formData.append('tokenInputParameter', Base64.encode(parameterData));

        // if file data pass then it will add in form data input parameter
        if (fileData != ''){
            Object.values(fileData).map(file => {
                formData.append('file[]', file);
            });
        }

        await axiosInstance({
            method: "post",
            url: config.RootUrl + apiPath,
            data: formData,
            headers: {
                Accept: "application/json",
                "Content-Type": "multipart/form-data"
            },
        }).then((response) => {
            
            let jsonResponse = {};

            if(typeof response.data == 'string' && response.data.includes('{')){
                console.log(response,"response");

                console.log(type,"api name");
                
                jsonResponse = JSON.parse(response.data);
            }else{
                jsonResponse = response.data;
            }
            
            if (jsonResponse.errorCode == "401") {
                this.generateTokenAPICall();
                apiResult.expired = true;
            }
            else if (jsonResponse.success == 'true' || jsonResponse.success) {
                apiResult.success = true;
                apiResult.APIResult = jsonResponse;
            }

        }).catch(err => console.log("Library API call error", err))

        return apiResult;
    }

    static generateTokenAPICall = (type, info) => {
        let formData = new FormData();
        formData.append('GenerateAccessToken', true);

        let parameterData = JSON.stringify({
            source: 'web',
            uid: userId,
            email: userEmail,
            role: userRole
        });

        formData.append('data', Base64.encode(parameterData));

        axios({
            method: "post",
            url: config.RootUrl + "/api/tokenmanagement.php",
            data: formData,
            headers: {
                Accept: "application/json",
                "Content-Type": "multipart/form-data"
            },
        }).then((response) => {
            let jsonResponse = response.data;
            if (jsonResponse.status == 'success') {
                function setCookie(name,value) {
                    document.cookie = name + "=" + (value || "") + "; path=/;";
                }

                // config.user_token = jsonResponse.data.user_token;
                // config.sync_token = jsonResponse.data.sync_token;

                // setCookie('user_token', jsonResponse.data.user_token);
                // setCookie('sync_token', jsonResponse.data.sync_token);


                function setWcCookie(name, value) {
                    document.cookie = name + "=" + (value || "") + "; path=/;domain=.vmedulife.com";
                }

                config.user_token = jsonResponse.data.user_token;
                config.sync_token = jsonResponse.data.sync_token;



                let userData = {};
                const userDetailsCookie = getCookie('user_details');
                if (userDetailsCookie) {
                    try {
                        const firstDecode = Base64.decode(userDetailsCookie);
                        const secondDecode = Base64.decode(firstDecode);
                        const userDetails = JSON.parse(secondDecode);



                        userDetails['data']['DeviceId'] = jsonResponse.deviceId || config.deviceId;
                        config.deviceId = jsonResponse.deviceId || config.deviceId;

                        const encodedDeviceData = Base64.encode(Base64.encode(JSON.stringify(userDetails)));
                        setCookie('user_details', encodedDeviceData);
                        setWcCookie('user_details_wc', encodedDeviceData);

                    } catch (err) {
                        console.error("Error decoding user_details cookie:", err);
                    }
                }

                setCookie('user_token', jsonResponse.data.user_token);
                setCookie('sync_token', jsonResponse.data.sync_token);
                setWcCookie('user_token_wc', jsonResponse.data.user_token);
                setWcCookie('sync_token_wc', jsonResponse.data.sync_token);
                // 🔄 Notify other tabs about new token 
                localStorage.setItem("token_update", Date.now().toString());
            }

        }).catch(err => console.log("Generate token api error", err))
    }

    getStreamData = () => {
        let formData = new FormData();
        formData.append("getInstituteStreamList", true);
        formData.append("iid", config.institute_id);

        axios({
            method: "post",
            url: config.RootUrl + "/api/generic_api.php",
            data: formData,
            headers: {
                Accept: "application/json",
                "Content-Type": "multipart/form-data",
            },
        }).then((response) => {
            let jsonResponse = response.data;
            streamData = jsonResponse.streamData;
        }).catch(error => {
            console.log(error);
        });
    }

}

export default LibraryApiCall;